import { c as _c } from "react/compiler-runtime";
import type { UserTimelineEventExternalIntegrationCalled } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import EventBodyEntry from '../event-body-entry';
type WorkflowTriggeredEventBodyProps = {
  data: UserTimelineEventExternalIntegrationCalled['data'];
};
const WorkflowTriggeredEventBody = t0 => {
  const $ = _c(8);
  const {
    data
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "auditTrail.timeline.externalIntegrationCalled"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== data.externalId) {
    t3 = <p className="text-body-2 text-tertiary ml-1">{data.externalId}</p>;
    $[3] = data.externalId;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <EventBodyEntry content={<p className="text-label-2 text-secondary">{t2}{t3}</p>} />;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export default WorkflowTriggeredEventBody;
function _temp($) {
  return $.uuid;
}